module.exports = __webpack_public_path__ + "static/img/program_05.9e72b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_05.jpg
// module id = xftH
// module chunks = 0